import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { DataGrid } from "@mui/x-data-grid";
import DetailsButtonCell from "./DetailsButtonCell";

const CustomNoRowsOverlay = () => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        flexDirection: "column"
      }}
    >
      There is no data
    </div>
  );
};

const VergenceTestsGrid = React.memo(function({ data, userId }) {
  const [rows, setRows] = React.useState([]);
  const [isEditing, setIsEditing] = React.useState(false);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [rowToDelete, setRowToDelete] = React.useState(null);
  const [docToDelete, setDocToDelete] = React.useState(null);

  React.useEffect(() => {
    setRows(data);
  }, [data]);
  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.5,
      align: "center",
      headerAlign: "center"
    },
    {
      field: "total",
      headerName: "Total",
      flex: 1,
      align: "center",
      type: "number",
      headerAlign: "center"
    },
    {
      field: "answeredOn",
      headerName: "Answered On",
      flex: 1,
      align: "center",
      type: "date",
      headerAlign: "center",
      valueGetter: params => {
        return new Date(params.row.answeredOn);
      },
      valueFormatter: params => {
        return params.value.toLocaleDateString();
      }
    },
    {
      field: "details",
      headerName: "Details",
      flex: 1,
      align: "center",
      headerAlign: "center",
      renderCell: params => <DetailsButtonCell row={params.row} />
    },
    {
      field: "delete",
      headerName: "Delete",
      flex: 0.5,
      align: "center",
      headerAlign: "center",
      renderCell: params => (
        <Button color="secondary" onClick={() => initiateDelete(params.row)}>
          Delete
        </Button>
      ),
      sortable: false,
      filterable: false,
      disableColumnMenu: true
    }
  ];

  const initiateDelete = id => {
    console.log(id.s);
    setRowToDelete(id.id);
    setDocToDelete(id.session);
    setOpenDialog(true);
  };

  const confirmDelete = async () => {
    if (rowToDelete && docToDelete) {
      try {
        const response = await fetch(
          "https://europe-central2-imvi-read.cloudfunctions.net/delete-vergence-test",
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({ sessionId: docToDelete })
          }
        );

        const data = await response.json();
        if (response.ok) {
          // If the delete was successful, remove the row from the local state
          setRows(prevRows => {
            const newRows = prevRows.filter(row => row.id !== rowToDelete);
            return newRows;
          });
          setDocToDelete(null);
          setRowToDelete(null);
        } else {
          // Handle any errors returned from the server
          console.error("Failed to delete the record: ", data.error);
        }
      } catch (error) {
        // Handle any errors during the fetch call
        console.error("Error while calling the delete API: ", error);
      }
    }

    // Close the confirmation dialog
    setOpenDialog(false);
  };

  const cancelDelete = () => {
    setRowToDelete(null);
    setDocToDelete(null);
    setOpenDialog(false);
  };
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        height: 350,
        width: "100%",
        "& .actions": {
          color: "text.secondary"
        },
        "& .textPrimary": {
          color: "text.primary"
        }
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        editMode="row"
        sx={{
          ".MuiDataGrid-selectedRowCount": {
            visibility: "hidden"
          }
        }}
        slots={{
          noRowsOverlay: CustomNoRowsOverlay
        }}
        pageSizeOptions={[5, 10, 15]}
        initialState={{
          sorting: {
            sortModel: [
              {
                field: "answeredOn",
                sort: "desc"
              }
            ]
          }
        }}
        slotProps={{
          toolbar: {
            setRows,
            rows,
            isEditing,
            setIsEditing
          }
        }}
      />
      <Dialog
        open={openDialog}
        onClose={cancelDelete}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={cancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="primary" autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
});
export default VergenceTestsGrid;
